<template>
  <div class="c-date-picker">
    <template v-if="isDesktopDevice">
      <div class="c-date-picker__scroll" v-dragscroll @dragscrollstart="addDraggingClass" @dragscrollend="removeDraggingClass">
        <div id="c-datepicker" class="c-date-picker__trigger"></div>
      </div>
    </template>
    <template v-else>
      <div class="c-date-picker__scroll">
        <div id="c-datepicker" class="c-date-picker__trigger"></div>
      </div>
    </template>

  </div>

</template>

<script>
import {EventBus} from "../event-bus"
import moment from 'moment'

export default {
  name: "DatePicker",
  props: ['startDate', 'endDate'],
  data() {
    return {
      datePicker: false,
      datePickerOpen: false,
      date: false,
      isDesktopDevice: true,
    };
  },
  beforeMount() {
    if ("ontouchstart" in document.documentElement) {
      this.isDesktopDevice = false
    }
  },
  mounted() {

    this.setupDatePicker()
    this.scrollToToday()

    EventBus.$on('updateDatePicker', this.updateDatePicker)
  },
  methods: {
    dateSelected(date) {
      this.date = date;
    },
    updateDatePicker(month) {
      const date = moment(month).format("DD MMM YYYY")
      this.datePicker.gotoDate(date)
      this.datePicker.setDate(date)
      const ele = document.querySelector('.c-date-picker__scroll')
      const todayElement = this.datePicker.ui.shadowRoot.querySelector('.today')

      ele.scroll({
        left: todayElement ? todayElement.offsetLeft : 0,
        top: 0,
        behavior: 'smooth'
      })
    },
    scrollToToday() {
      const todayElement = this.datePicker.ui.shadowRoot.querySelector('.today')
      if (todayElement) {
        const resizeObserver = new ResizeObserver(entries => {
          const lastEntry = entries.pop();

          // alternatively use contentBoxSize here
          // Note: older versions of Firefox (<= 91) provided a single size object instead of an array of sizes
          // https://bugzilla.mozilla.org/show_bug.cgi?id=1689645
          const width = lastEntry.borderBoxSize?.inlineSize ?? lastEntry.borderBoxSize[0].inlineSize;
          const height = lastEntry.borderBoxSize?.blockSize ?? lastEntry.borderBoxSize[0].blockSize;

          if (width > 0 && height > 0) {
            // We know the today element has rendered then scroll into view
            const ele = document.querySelector('.c-date-picker__scroll')
            ele.scroll({
              left: todayElement ? todayElement.offsetLeft : 0,
              top: 0,
              behavior: 'smooth'
            })
            resizeObserver.disconnect();
          }

        });

        resizeObserver.observe(todayElement);
      }

    },
    addDraggingClass() {
      this.datePicker.ui.shadowRoot.firstChild.classList.add('dragging')
    },
    removeDraggingClass() {
      this.datePicker.ui.shadowRoot.firstChild.classList.remove('dragging')
    },
    setupDatePicker() {
      const format = "DD MMM YYYY"

      this.datePicker = new easepick.create({
        element: document.getElementById('c-datepicker'),
        format: format,
        plugins: ['LockPlugin', 'KbdPlugin'],
        LockPlugin: {
          minDate: moment(this.startDate).format(format),
          maxDate: this.endDate != false ? moment(this.endDate).format(format) : '',
        },
        css: [
          'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
          '/themes/childtheme/assets/css/easepick-overrides.css',
        ],
        grid: 3,
        calendars: 3,
        zIndex: 10,
        inline: true,
        setup(picker) {
          picker.on('select', (event) => {
            EventBus.$emit('dateSelected', event.detail.date.format('YYYY-MM-DD'));
          });
        },
      });

      this.datePicker.on('view', (evt) => {
        const { view, date, target } = evt.detail
        const d = date ? moment(date.format('YYYY-MM-DD')).format('ddd') : null

        if (view === 'CalendarDay' && d) {
          const span = target.querySelector('.day-name-label') || document.createElement('span');
          span.className = 'day-name-label';
          span.innerHTML = d;
          target.append(span);
        }
      });

      this.datePicker.show()
      this.datePicker.gotoDate(moment(this.startDate).format(format))
    },
    resetFilter() {
      this.dateRange = false;
      this.datePicker.clear();
    },
  }
}
</script>
